// extracted by mini-css-extract-plugin
module.exports = {"counters":"Counters_counters__nlHvy","counter":"Counters_counter__MK_PA","counter_new":"Counters_counter_new__oWpEg","counter_updated":"Counters_counter_updated__2urHb"};